import { MechanicalAspectService } from '../model/mechanical-aspect.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { MechanicalAspect } from 'assets-model';
import { Observable } from 'rxjs';


export class MechanicalAspectDataSource extends CrudDataSource<MechanicalAspect> {

  constructor(private service: MechanicalAspectService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<MechanicalAspect>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


